// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import CheckboxPresentationPropsDefault from "@insite/mobius/Checkbox/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...CheckboxPresentationPropsDefault,
        css: css`
            &:hover {
                cursor: pointer;
            }
            span[role="checkbox"] + label {
                margin-left: 6px !important;
            }
            span[role="checkbox"] {
                border-radius: 0px;
                width: 18px;
                height: 18px;
                background: ${getColor("common.white")};
                position: relative;
                border: 1px solid ${getColor("text")} !important;

                svg {
                    margin: auto;
                    color: ${getColor("common.white")};
                    fill: ${getColor("common.white")};
                    width: 13px;
                    height: 13px;
                }

                &[aria-checked="false"] {
                    svg {
                        // removing shaking when toggling
                        visibility: hidden !important;
                        display: block;
                    }
                    &:hover {
                        svg {
                            // removing shaking when toggling
                            visibility: hidden !important;
                        }
                        background: ${getColor("text")};
                    }
                }

                &[aria-checked="true"] {
                    background: ${getColor("text")} !important;
                    &:hover:not([aria-disabled="true"]) {
                        svg {
                            // removing shaking when toggling
                            visibility: hidden !important;
                        }
                    }
                    &:focus {
                        &:focus,
                        &:active {
                            svg {
                                // removing shaking when toggling
                                visibility: visible !important;
                            }
                        }
                    }
                }

                &[aria-disabled="true"][aria-checked="false"] {
                    background: ${getColor("common.white")};
                }

                &:focus {
                    &:focus,
                    &:active {
                        box-shadow: none;
                        border: 2px solid ${getColor("text")} !important;
                    }
                }

                &[aria-disabled="true"] {
                    cursor: not-allowed;
                    opacity: 0.5;

                    &:focus,
                    &:hover,
                    &:active {
                        box-shadow: none;
                        &:before {
                            content: none;
                        }
                    }

                    + label {
                        cursor: not-allowed;
                        opacity: 0.5;
                    }
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["checkbox"];
